var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { modalId, txtModalHeader, txtModalBody, txtBtnCancel, txtBtnConfirm, confirmBtnId } = options; 
__p+='\n\n<div class="modal fade move-confirm-box" id="'+
((__t=( modalId ))==null?'':__t)+
'" tabindex="-1" role="dialog" aria-hidden="true">\n  <div class="modal-dialog modal-sm">\n    <div class="modal-content">\n      <div class="modal-header">\n        <h2>\n          '+
((__t=( txtModalHeader ))==null?'':__t)+
'\n        </h2>\n      </div>\n      <div class="modal-body">\n        '+
((__t=( txtModalBody ))==null?'':__t)+
'\n      </div>\n      <div class="modal-footer">\n        <button type="button" class="btn btn-primary" data-dismiss="modal">\n          '+
((__t=( txtBtnCancel ))==null?'':__t)+
'\n        </button>\n        <button id="'+
((__t=( confirmBtnId ))==null?'':__t)+
'" type="button" class="btn btn-default">\n          '+
((__t=( txtBtnConfirm ))==null?'':__t)+
'\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/dialog.jst.ejs